
export default {
  props: ["open"],
  data() {
    return {
      tab: "products",
      brands: [],
      needs: [],
      active: "",
      active2: "",
    };
  },
  async mounted() {
    // cmsPreload populates store.cms without being awaited, so on a fast mount
    // these are still empty and we fetch them ourselves. Run both in parallel.
    await Promise.all([this.loadCmsList("brands"), this.loadCmsList("needs")]);
  },
  methods: {
    // $cms.get resolves to the whole response; the list is on .docs. Assigning
    // the response object left `.length` undefined and the tab hidden (#23413).
    async loadCmsList(title) {
      const cached = this.$store.getters.cms[title];
      if (cached && cached.length) {
        this[title] = cached;
        return;
      }
      try {
        const res = await this.$cms.get({ title, limit: 400 });
        this[title] = res?.docs || this.$store.getters.cms[title] || [];
      } catch (e) {
        this[title] = this.$store.getters.cms[title] || [];
      }
    },
    async recalc(index, index2) {
      setTimeout(() => {
        try {
          let mobileMenu = document.querySelector("#mobileMenuSlider");
          if (mobileMenu) {
            mobileMenu.swiper.updateAutoHeight(500);
          }
        } catch (e) {
          console.error(e);
        }
      }, 1000);
      if (!isNaN(index) && !this.active) {
        return;
      }
      if (!isNaN(index2) && !this.active2) {
        return;
      }
      await new Promise((res) => setTimeout(res, 500));
      if (!isNaN(index2)) {
        this.$hyperUtility.scrollHeight(
          `.menu_panel_${index}_${index2}`,
          "maxHeight"
        );
        await new Promise((res) => setTimeout(res, 500));
      }
      this.$hyperUtility.scrollHeight(`.menu_panel_${index}`, "maxHeight");
    },
  },
};
